import React from 'react';

const ParagraphSection = ({ paragraphs }) => (
  <div>
    {paragraphs.map(p => {
      return(
        <p key={p.heading}>
          <strong>{p.heading}</strong>&nbsp;
          {p.text}
        </p>
      );
    })}
  </div>
);

export default ParagraphSection;


// WEBPACK FOOTER //
// ./src/components/ParagraphSection.js